
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Existing pages use fetch directly. Attach the JWT consistently for API
// requests while preserving the public login, health, and share-link routes.
const nativeFetch = window.fetch.bind(window);
const publicApiPaths = [
  '/api/auth/login',
  '/api/health',
  '/api/share-file/',
  '/api/link-status/',
  '/api/trade/share/',
];

window.fetch = (input, init = {}) => {
  const url = typeof input === 'string' ? input : input?.url || '';
  const isApiRequest = url.startsWith('/api/') || url.startsWith(window.location.origin + '/api/');
  const path = url.startsWith(window.location.origin) ? url.slice(window.location.origin.length) : url;
  const isPublic = publicApiPaths.some((publicPath) => path.startsWith(publicPath));
  const token = localStorage.getItem('token');

  let requestInit = init;
  if (isApiRequest && !isPublic && token) {
    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    if (!headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    requestInit = { ...init, headers };
  }

  return nativeFetch(input, requestInit).then((response) => {
    if (isApiRequest && !isPublic && response.status === 401) {
      ['token', 'userRole', 'userEmail', 'userId', 'userName', 'allowedProjects'].forEach(
        (key) => localStorage.removeItem(key)
      );
      const tradePortal = window.location.hostname.toLowerCase().startsWith('trade.')
        || window.location.pathname.startsWith('/trade');
      const loginPath = tradePortal ? '/trade' : '/';
      if (window.location.pathname !== loginPath) {
        window.location.assign(loginPath);
      }
    }
    return response;
  });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
